<template>
    <v-card elevation="0">
        <v-card elevation="0" outlined width="100%">
            <v-card-actions class="ma-2 pa-0">
                <v-btn class="green white--text pr-5" elevation="0" @click="onPressCreate()"><v-icon class="mr-2">mdi-plus</v-icon>Create Hero</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="blue white--text pr-3" elevation="0" @click="onPressExport()"><v-icon class="mr-2">mdi-clipboard-check-outline</v-icon>Export</v-btn>
            </v-card-actions>
        </v-card>

        <utils-heroes-pop-edit ref="utils-heroes-pop-edit"></utils-heroes-pop-edit>

        <v-card elevation="0" outlined width="100%" class="mt-2 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-card width="100%" elevation="0">
                    <v-card-title>
                        <v-text-field
                            outlined
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            clearable
                            hide-details
                            dense
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            style="width: 100%;"
                            fixed-header
                            :items="getData"
                            
                            :headers="headers"
                            :search="search"
                            :single-select="false"
                            item-key="key"
                            hide-default-footer
                            
                            disable-pagination>

                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                            color="green"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-1"
                                            @click="onPressEdit(item)">
                                        <v-icon size="22">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                           color="red"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="mr-1"
                                           @click="onPressDelete(item)">
                                        <v-icon size="22">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </template>

                    </v-data-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import {serialize} from "serializr";
import { HeroKind } from "@/modules/redactor/models/hero/HeroKind";
import UtilsHeroesPopEdit from "./heroes/utils-heroes-pop-edit.vue";
import { HeroKindStoreUtils } from "../../mherokind/database/HeroKindStoreUtils";


export default {
    name: "utils-heroes-page",
    components: {UtilsHeroesPopEdit},
    data: () => ({
        data: {},
        search: '',
        headers: [
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red"},
            {text: 'Key', sortable: true, value: 'key', class: "white blue--text", color: "red"},
            {text: 'Code', sortable: true, value: 'code', class: "white blue--text", color: "red"},
            {text: 'Emotions', sortable: true, value: 'emotions', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'15%', align:'end'}
        ],
    }),
    methods:{
        isDuplicateHero(newHero) {
            return this.getData.some(hero =>
                (hero.key === newHero.key || hero.code === newHero.code) && hero !== newHero // exclude self when editing
            );
        },
        getList(){
            console.log("getList");
            this.data = HeroKindStoreUtils.getHeroKinds();
        },
        onPressExport() {

          let data = this.data.map(v => {
            const raw = serialize(HeroKind, v);

            return {
              code: raw.code,
              key: raw.key,
              name: raw.name,
              worker: raw.worker,
              emotions: raw.emotions
            };
          });

          const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "heroes.json";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$notify({title: 'Exported', text: "", type: "success"});
        },
        onPressCreate(){
            let data = new HeroKind();
            console.log("create:", data.key, data);
            this.onPressEdit(data);
        },
        saveData(data) {
            if (this.isDuplicateHero(data)) {
                this.$notify({title: 'Duplicate Hero detected!', text: "A hero with the same key or code already exists.", type: "error"});
                return;
            }
            let self = this;
            HeroKindStoreUtils.createHeroKind(data).then(() => {
                self.getList();
                self.$notify({title: 'Saved', text: "", type: "success"});
            }, (reason) => {
                self.$notify({title: 'Save failed', text: reason, type: "error"});
            });
        },
        onPressDelete(item){
            let self = this;
            this.$confirm("Are you sure?").then(() => {
                HeroKindStoreUtils.deleteHeroKind(item.key).then(() => {
                    self.getList();
                }, (reason) => {
                    self.$notify({title: 'Delete failed', text: reason, type: "error"});
                });
            }).catch(() => {})
        },
        onPressEdit(item){
            let self = this;
            let origin = JSON.stringify(serialize(HeroKind, item))
            this.$refs['utils-heroes-pop-edit'].show(item,function (model) {
                let edited = JSON.stringify(serialize(HeroKind, model))
                if (edited == origin){
                    return;
                }

                self.saveData(model);
            })
        },
    },
    computed:{
        winsize() {
            return window.app.winsize;
        },
        getData(){
            console.log(Object.values(this.data));
            return Object.values(this.data);
        }
    },
    created() {
        this.getList();
    }

}
</script>

<style scoped>
.scroll {
    overflow-y: scroll
}
</style>